import { pasos, premios, beneficios } from "@/config/brands/ofertaCommon";

describe("ofertaCommon config", () => {
  describe("Pasos", () => {
    test("Pasos should have the steps: thank, mensaje, clienteCA, mensajeErrorSolicitudCuenta", () => {
      expect(pasos).toHaveProperty("thank");
      expect(pasos).toHaveProperty("mensaje");
      expect(pasos).toHaveProperty("clienteCA");
      expect(pasos).toHaveProperty("mensajeErrorSolicitudCuenta");
    });
  });

  describe("Premios", () => {
    test("Premios array should have specific structure", () => {
      premios.forEach(premio => {
        expect(premio).toHaveProperty("label");
        expect(premio).toHaveProperty("icon");
      });
    });
  });

  describe("Beneficios", () => {
    test("Beneficios array should have specific structure", () => {
      beneficios.forEach(beneficio => {
        expect(beneficio).toHaveProperty("label");
        expect(beneficio).toHaveProperty("description");
      });
    });
  });
});
